import * as THREE from 'three';
import EventDispatcher from './EventDispatcher';
import { gsap, Expo } from 'gsap';
import Global from './Global';

export default class Camera extends THREE.PerspectiveCamera {
  zLerp = new THREE.Vector3();
  yLerp = new THREE.Vector3();
  xLerp = new THREE.Vector3();
  gameStarted = false;
  constructor(fov, ratio, near, far) {
    super(fov, ratio, near, far);
  }
  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('CAMERA_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('PLAYER_EVENTS', this.onEvents.bind(this));

    this.position.set(0, 0, 0);
    // this.rotation.set(0,0,-1)
    // this.rotation.set(0,.1, .05);
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'resize':
        this.onResize(data['message']['data']);
        break;
      case 'update':
        this.update();
        break;
    }
  }
  onResize(data) {
    this.aspect = data.aspect;
    this.updateProjectionMatrix();
  }
  update() {}
}
